import { render, staticRenderFns } from "./LegalDisclaimer.vue?vue&type=template&id=e158df92&"
import script from "./LegalDisclaimer.vue?vue&type=script&lang=js&"
export * from "./LegalDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports